import { Icon } from '@assembly-js/design-system';

import { StudioChecklistTaskStatus } from './studioChecklist';

interface StatusMarkIconProps {
  status: StudioChecklistTaskStatus;
}

export const StatusMarkIcon = ({ status }: StatusMarkIconProps) => {
  if (status === StudioChecklistTaskStatus.Done) {
    return (
      <Icon
        icon="SuccessSolid"
        aria-hidden="true"
        className="size-3.5 shrink-0 text-black-heading"
      />
    );
  }

  if (status === StudioChecklistTaskStatus.InProgress) {
    return (
      <span
        aria-hidden="true"
        className="box-border block size-3.5 shrink-0 rounded-full border-[1.5px] border-solid border-light-gray text-light-gray"
        style={{
          backgroundImage:
            'linear-gradient(90deg, currentColor 50%, transparent 50%)',
        }}
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      className="box-border block size-3.5 shrink-0 rounded-full border-[1.5px] border-solid border-light-gray"
    />
  );
};
